import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseBrandingWrapper from 'components/EnterpriseBrandingWrapper';
import EnterpriseContext from '../RwcAnalytics/providers/Enterprise/Enterprise.context';

import './Branding.styles.scss';

type BrandingProps = {
  className?: string;
};

const Branding: React.FC<BrandingProps> = (props) => {
  const { className } = props;

  const classes = classNames('branding', className);

  const { enterprise, updateEnterprise } = useContext(EnterpriseContext);

  return (
    <div className={classes}>
      <EnterpriseBrandingWrapper
        enterprise={enterprise}
        updateEnterprise={updateEnterprise}
      />
    </div>
  );
};

export default Branding;
